import clsx from 'clsx';
import React from 'react';

import type { TITVBlockProps } from '../interfaces';

const TITVBlock = ({ config, episode }: TITVBlockProps) => {
  if (!episode?.videoId) return null;

  return (
    <div className={clsx('titv-block mx-auto w-full max-w-container-lg', config?.css_classes)}>
      <div className="relative aspect-[16/9] w-full">
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${episode.videoId}?rel=0&playsinline=1&modestbranding=1`}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          title={episode.title || 'TITV Episode'}
          className="absolute inset-0 h-full w-full border-0"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default TITVBlock;
